<template>
  <v-col cols="12">
    <v-row justify="space-between" align="center">
      <v-img :src="logo" max-height="50" max-width="130" class="mr-auto"></v-img>
      <v-col cols="12" md="6" align="end" v-if="showUsernameAndInfo">
        <v-menu
          v-model="messagesMenu"
          left
          bottom
          :close-on-content-click="false"
          content-class="my-menu"
          max-width="380"
          nudge-top="-30"
          nudge-right="140"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon elevation="0" large>
              <v-img
                v-if="messages.length"
                :src="'/img/user/message-pending.svg'"
                max-height="40"
                max-width="40"
              ></v-img>
              <v-img v-else :src="'/img/user/icon-mail.svg'" max-height="30" max-width="30"></v-img>
            </v-btn>
          </template>
          <v-card elevation="0" class="overflow-y-auto ma-4" max-height="360" min-width="360">
            <v-list dense class="py-0 pr-2" v-if="messages.length">
              <div v-for="({ message }, i) in messages" :key="i">
                <v-list-item class="text-center px-1" @click="openMessage(message)">
                  <v-row align="center">
                    <v-col cols="3" align="center">
                      <strong class="color-primary">
                        {{ getRemaingTime(message.issueDate) }}
                      </strong>
                    </v-col>
                    <v-col cols="9" class="pa-1">
                      <h5
                        class="mb-2 text-left text-subtitle-2 color-primary text-capitalize font-weight-bold"
                      >
                        {{ $utils.upperFirstLetter(message.fromUser.firstname) }}
                      </h5>
                      <p class="text-left text-caption mt-0 mb-1 color-primary">
                        {{ message.subject }}
                      </p>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="my-2" />
              </div>
            </v-list>
            <v-list dense class="py-0 pr-2" v-else>
              <v-list-item class="text-center px-1">
                <v-row align="center">
                  <v-col cols="12" class="pa-1">
                    <h5 class="mb-2 text-center text-h6 color-primary">
                      {{ $t('home.no_message') }}
                    </h5>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu
          v-model="notificationsMenu"
          left
          bottom
          :close-on-content-click="false"
          content-class="my-menu"
          max-width="380"
          nudge-top="-30"
          nudge-right="140"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon elevation="0" class="mx-1 mx-md-3" large>
              <v-img
                src="/img/user/notification-pending.svg"
                max-height="40"
                max-width="40"
              ></v-img>
            </v-btn>
          </template>
          <v-card elevation="0" class="overflow-y-auto ma-4" max-height="360">
            <v-list dense class="py-0 pr-2">
              <div v-for="(noti, i) in notifications" :key="i">
                <v-list-item class="text-center px-1" v-if="noti.show" @click="redirectTo(noti.to)">
                  <v-row align="center">
                    <v-col cols="2" align="center">
                      <v-img :src="noti.icon" max-height="40" max-width="40"></v-img>
                    </v-col>
                    <v-col cols="10" class="pa-1">
                      <h5 class="mb-2 text-left text-subtitle-2 color-primary font-weight-bold">
                        {{ noti.title }}
                      </h5>
                      <p class="text-left text-caption mt-0 mb-1 color-primary">
                        {{ noti.desc }}
                      </p>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider class="my-2" v-if="noti.show" />
              </div>
            </v-list>
          </v-card>
        </v-menu>
        <span class="mx-1 mx-md-4 text-capitalize" v-show="showUsername">
          {{ username }}
        </span>

        <v-menu
          v-model="userMenu"
          right
          bottom
          :close-on-content-click="true"
          content-class="my-profile"
          width="250"
          nudge-top="-20"
          nudge-right="-50"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon elevation="0" color="primary" class="pa-1" x-large>
              <AvatarIcon :avatar="stUserAvatar" v-if="stUserAvatar"></AvatarIcon>
              <span v-else class="text-uppercase primary--text">A</span>
            </v-btn>
          </template>
          <v-list dense class="mx-2 text-left text-caption">
            <v-list-item to="/user/profile" class="px-2" data-cy="topBar-profile-btn">
              <v-row class="mx-0 px-0" align="center">
                <v-img src="/img/user/icon_my_profile.svg" max-height="25" max-width="25"></v-img>
                <span class="ml-2 font-weight-bold color-primary">
                  {{ $t('home.my_profile') }}
                </span>
              </v-row>
            </v-list-item>
            <v-list-item to="/user/library" class="px-2">
              <v-row class="mx-0 px-0" align="center">
                <v-img src="/img/user/icon_my_books.svg" max-height="25" max-width="25"></v-img>
                <span class="ml-2 font-weight-bold color-primary">
                  {{ $t('home.my_books') }}
                </span>
              </v-row>
            </v-list-item>
            <!-- <v-list-item to="/user/library" class="px-2">
                            <v-row class="mx-0 px-0" align="center">
                                <v-img
                                    src="/img/user/icon_my_subscriptions.svg"
                                    max-height="25"
                                    max-width="25"
                                ></v-img>
                                <span class="ml-2 font-weight-bold color-primary">
                                    {{ $t('home.my_subscriptions') }}
                                </span>
                            </v-row>
                        </v-list-item> -->
            <v-list-item to="/user/ranking" class="px-2">
              <v-row class="mx-0 px-0" align="center">
                <v-img src="/img/user/icon_ranking.svg" max-height="25" max-width="25"></v-img>
                <span class="ml-2 font-weight-bold color-primary">
                  {{ $t('home.ranking') }}
                </span>
              </v-row>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <MessageModal
      :dialog="true"
      :message_data="currentMessage"
      v-if="currentMessage"
      @close-modal="closeMessage"
    />
  </v-col>
</template>

<script>
/* eslint-disable global-require */

import { mapState } from 'vuex'

import MessageService from '@/services/message'

import AvatarIcon from './AvatarIcon.vue'
import MessageModal from './modals/MessageModal.vue'

export default {
  components: {
    AvatarIcon,
    MessageModal,
  },
  computed: {
    ...mapState({
      user: (state) => state.userData.user,
      existAssignedBook: (state) => state.userData.existAssignedBook,
      assignedBookId: (state) => state.userData.assignedBookId,
      messages: (state) => state.userData.recievedMessages,
      stUserAvatar: (state) => state.userData.avatarSelected,
    }),
    username() {
      return this.setName(this.user)
    },
    showUsername() {
      return this.$router.currentRoute.path !== '/user/profile'
    },
    showUsernameAndInfo() {
      return this.$router.currentRoute.path !== '/user/store'
    },
  },
  watch: {
    existAssignedBook(newValue) {
      if (newValue) {
        this.notifications[0].show = true
        this.notifications[0].to = `/user/book/${this.assignedBookId}`
      }
    },
  },
  data() {
    return {
      logo: require('@/assets/img/brand/logo.svg'),
      messagesMenu: false,
      notificationsMenu: false,
      userMenu: false,
      currentMessage: null,
      showMessage: false,
      notifications: [
        {
          icon: '/img/user/reminder.svg',
          title: 'Recordatorio',
          value: 'bookAssigment',
          desc: this.$t('home.notification_text_1'),
          to: `/user/book/${this.assignedBookId}`,
          show: this.existAssignedBook,
          read: false,
        },
        {
          icon: '/img/user/store.svg',
          title: 'Novedades de tu tienda',
          value: 'store',
          show: true,
          to: '/user/store',
          desc: this.$t('home.notification_text_2'),
          read: false,
        },
        {
          icon: '/img/user/library.svg',
          title: 'Novedades de la biblioteca',
          value: 'library',
          show: true,
          to: '/user/library',
          desc: this.$t('home.notification_text_3'),
          read: false,
        },
      ],
    }
  },
  methods: {
    getRemaingTime(date = '') {
      return this.$moment(date).fromNow()
    },
    openMessage(data) {
      this.currentMessage = data
      this.messagesMenu = false
      this.showMessage = true
    },
    closeMessage() {
      this.showMessage = false
      // MessageService.setReadMessages({ idList: [this.currentMessage.id] })
      // const found = this.messages.find((i) => i.message.id === this.currentMessage.id)
      // this.messages.splice(this.messages.indexOf(found), 1)
      this.currentMessage = null
    },
    redirectTo(to = '') {
      this.notificationsMenu = !this.notificationsMenu

      // Avoid redundant navigation
      if (to && this.$router.history.current.path !== to) this.$router.push(to)
    },
    setName(data) {
      return `${this.capitalizeText(data.firstname.split(' ')[0])} ${this.capitalizeText(
        data.lastname.split(' ')[0]
      )}`
    },
    capitalizeText(text) {
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    },
  },
}
</script>
<style scoped>
.color-primary {
  color: #514773;
}

.v-list-item,
.v-list-item:before {
  border-radius: 10px;
}

.v-list-item:hover {
  background-color: #f3efff;
}

.v-menu__content {
  background-color: #ffff;
  border-radius: 10px;
}

.my-menu {
  contain: initial;
  overflow: visible;
}

.my-menu:after {
  /* This is the shadow triangle */
  position: absolute;
  top: -22px;
  right: 145px;
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 22px solid rgba(0, 0, 0, 0.03);
  z-index: 1;
}
.my-menu::before {
  position: absolute;
  content: '';
  top: 0;
  right: 150px;
  transform: translateY(-100%);
  width: 15px;
  height: 20px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #fff;
  z-index: 2;
}

.my-profile {
  contain: initial;
  overflow: visible;
}

.my-profile:after {
  /* This is the shadow triangle */
  position: absolute;
  top: -22px;
  right: 19px;
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 22px solid rgba(0, 0, 0, 0.03);
  z-index: 1;
}
.my-profile::before {
  position: absolute;
  content: '';
  top: 0;
  right: 24px;
  transform: translateY(-100%);
  width: 15px;
  height: 20px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #fff;
  z-index: 2;
}
</style>
